/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useCallback, useMemo} from "react";
import {Button} from "react-bootstrap";

export function ValidatedFormButton(props) {
    
    const {
        className,
        onClick: originalOnClick,
        validations,
        isValid,
        disabled,
        ...remainingProps
    } = props;
    
    const firstValidationError = useMemo(() => {
        return Object.values(validations)?.find?.((validation) => !validation.valid);
    }, [validations]);
    
    const scrollToValidation = useCallback(() => {
        console.log("showValidation", firstValidationError);
        if (firstValidationError) {
            document.getElementById(firstValidationError?.id)?.parentElement?.scrollIntoView({ behavior: 'instant' });
        }
    }, [firstValidationError]);
    
    const onClick = useCallback((event) => {
        if (!isValid) {
            scrollToValidation();
            return false;
        }
        originalOnClick(event);
    }, [originalOnClick, isValid, scrollToValidation]);
    
    return <Button
        className={className ?? "" + isValid ? "" : "disabled"}
        onClick={onClick}
        {...remainingProps}
    >
        Save
    </Button>;
}
